<template>
  <BaseButton
    class="button-bubble"
    :class="{
      'button-bubble--primary': primary,
      'button-bubble--is-disabled': !isActive,
    }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!-- inner div needed for flexbox in button -->
    <div class="button-bubble__inner">
      <component :is="iconComponent" class="button-bubble__icon" />
      <span class="button-bubble__label">{{ label }}</span>
    </div>
  </BaseButton>
</template>

<script>
import BaseButton from '../ButtonBase';

const ICONS = {
  repeat: () => import('../../assets/icons/repeat.svg?inline'),
  share: () => import('../../assets/icons/share.svg?inline'),
};

export default {
  name: 'ButtonBubble',

  components: {
    BaseButton,
  },

  props: {
    icon: {
      type: String,
      required: true,
      validator: icon => Object.keys(ICONS).includes(icon),
    },

    isActive: {
      type: Boolean,
      default: true,
    },

    label: {
      type: String,
      required: true,
    },

    primary: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    iconComponent() {
      return ICONS[this.icon];
    },
  },
};
</script>

<style lang="scss" scoped>
a.button-bubble {
  cursor: inherit;
}

.button-bubble__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.button-bubble__icon {
  border-radius: 50%;
  padding: 11px;
  height: 18px;
  width: 18px;
  background-color: rgba($color-white, 0.15);
  transition: 0.2s ease;
  @include helper__composited-layer();
}

.button-bubble:active .button-bubble__icon {
  transform: scale(0.94);
  opacity: 0.8;
}

.button-bubble--primary {
  @include linear-gradient($color-purple, $color-blue, 45deg);
  border-radius: 50%;
}

.button-bubble__label {
  margin-top: 10px;
  text-align: center;
  color: $color-white;
  font-size: 12px;
}

.button-bubble--is-disabled {
  opacity: 0.4;
}
</style>
